import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "@/App.css";

import { translations } from '@/lib/translations';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ContractForm from '@/components/ContractForm/ContractForm';
import AdminPanel from '@/components/AdminPanel';
import CustomerSigningPage from '@/components/CustomerSigningPage';

function MainApp() {
  const [language, setLanguage] = useState('de');
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const t = translations[language];

  return (
    <div className="min-h-screen bg-gradient-hero">
      <Header 
        language={language} 
        setLanguage={setLanguage}
        t={t}
      />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <ContractForm language={language} />
      </main>

      <Footer t={t} onAdminClick={() => setIsAdminOpen(true)} />
      
      <AdminPanel 
        isOpen={isAdminOpen} 
        onClose={() => setIsAdminOpen(false)}
        language={language}
      />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/sign/:contractId" element={<CustomerSigningPage />} />
        <Route path="/*" element={<MainApp />} />
      </Routes>
    </Router>
  );
}

export default App;
